import { render, staticRenderFns } from "./BookConfirm.vue?vue&type=template&id=0a6c5b2a&"
import script from "./BookConfirm.vue?vue&type=script&lang=js&"
export * from "./BookConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports